
import { useState } from "react";
import { brandColors as colors } from "@/lib/palette";
import { fonts } from "@/lib/fonts";

type Category = {
  id: string;
  name: string;
  slug: string;
};

type Props = {
  categories: Category[];
  onFilter: (categoryId: string | null) => void;
};

export default function ShopCategoryFilter({ categories, onFilter }: Props) {
  const [active, setActive] = useState<string | null>(null);

  function handleClick(id: string | null) {
    setActive(id);
    onFilter(id);
  }

  if (categories.length === 0) return null;

  return (
    <div className="flex gap-2 flex-wrap justify-center mb-8">
      <button
        type="button"
        onClick={() => handleClick(null)}
        className="px-4 py-2 rounded-full text-xs cursor-pointer transition-all duration-200"
        style={{
          fontFamily: fonts.button,
          fontWeight: 700,
          letterSpacing: "0.05em",
          textTransform: "uppercase",
          backgroundColor: active === null ? colors.berryPink : "white",
          color: active === null ? "white" : colors.navy,
          border:
            active === null
              ? `1px solid ${colors.berryPink}`
              : `1px solid ${colors.tan}40`,
        }}
      >
        All
      </button>
      {categories.map((cat) => (
        <button
          key={cat.id}
          type="button"
          onClick={() => handleClick(cat.id === active ? null : cat.id)}
          className="px-4 py-2 rounded-full text-xs cursor-pointer transition-all duration-200"
          style={{
            fontFamily: fonts.button,
            fontWeight: 700,
            letterSpacing: "0.05em",
            textTransform: "uppercase",
            backgroundColor: active === cat.id ? colors.berryPink : "white",
            color: active === cat.id ? "white" : colors.navy,
            border:
              active === cat.id
                ? `1px solid ${colors.berryPink}`
                : `1px solid ${colors.tan}40`,
          }}
        >
          {cat.name}
        </button>
      ))}
    </div>
  );
}
